import {ChangeDetectorRef, Component, forwardRef, OnInit} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {appInjector} from "../../../index";
import {Medicine} from "../../model/medicine.type";
import {Substance} from "../../model/substance.type";
import {CreateMedicineResult, MedicineService, UpdateMedicineResult} from "../../services/medicine.service";
import {TypeaheadMatch} from "ngx-bootstrap";
import {ApolloQueryObservable} from "apollo-angular";
import {Observable} from "rxjs/Observable";
import {ApolloQueryResult} from "apollo-client";

@Component({
  selector: 'vb-medicine-form',
  templateUrl: './medicine-form.component.html',
  styleUrls: ['./medicine-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => MedicineFormComponent)}]
})
export class MedicineFormComponent extends AbstractVisbosControl<Medicine, FormGroup> implements OnInit {

  private substances$: ApolloQueryObservable<{ substances: Substance[] }>;
  substances: Substance[] = [];

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, private medService: MedicineService) {
    super(fb, cd, null);
  }

  ngOnInit() {
    super.ngOnInit();

    this.substances$ = this.medService.getSubstances();
    this.addComponentData(this.substances$);
    this.dataSubscriptions.push(this.substances$.subscribe(res => {
      this.substances = res.data.substances;
    }))
  }

  buildControlContent(): FormGroup {
    return MedicineFormComponent.initControl(this.fb);
  }


  onControlChanged() {
    super.onControlChanged();

    // Watch changes on custom capacity
    let capSub = this.control.get('custom_capacity').valueChanges.subscribe(val => {
      if (val) {
        this.control.get('capacity').setValue(null);
        this.control.get('capacity').disable();
      } else {
        this.control.get('capacity').enable();
        this.control.get('capacity').setValue(this.setValue(this.item, 'capacity', null));
      }
    });

    let dosSub = this.control.get('substances.0.custom_dosage').valueChanges.subscribe(val => {
      if (val) {
        this.control.get('substances.0.dosage').setValue(null);
        this.control.get('substances.0.dosage').disable();
      } else {
        this.control.get('substances.0.dosage').enable();
        this.control.get('substances.0.dosage').setValue(this.setValue(this.item, 'substances.0.dosage', null));
      }
    });

    this.dataSubscriptions.push(capSub, dosSub);


  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null, Validators.required],
      name: [null],
      notes: [null],
      dosage_form_id: [null, Validators.required],
      administration_unit_id: [null, Validators.required],
      custom_capacity: [null],
      capacity: [null],
      capacity_unit_id: [null],
      substances: fb.array([fb.group({
        cuid: [null, Validators.required],
        name: [null, Validators.required],
        administration_unit_id: [null, Validators.required],
        substance_group_id: [null, Validators.required],
        custom_dosage: [null],
        dosage: [null],
        dosage_unit_id: [null]
      })])
    });
  }

  public setDefaultValues(item?: Medicine): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      name: this.setValue(item, 'name'),
      notes: this.setValue(item, 'notes'),
      dosage_form_id: this.setValue(item, 'dosage_form.cuid'),
      administration_unit_id: this.setValue(item, 'administration_unit.cuid', this.activeAdminUnitCuid),
      capacity: this.setValue(item, 'capacity'),
      custom_capacity: this.setValue(item, 'custom_capacity', false),
      substances: [{
        cuid: this.setValue(item, 'substances.0.substance.cuid', AbstractVisbosControl.cuid()),
        administration_unit_id: this.setValue(item, 'administration_unit.cuid', this.activeAdminUnitCuid),
        name: this.setValue(item, 'substances.0.substance.name'),
        dosage: this.setValue(item, 'substances.0.dosage'),
        custom_dosage: this.setValue(item, 'substances.0.custom_dosage', false),
      }],
    }
  };

  public typeaheadOnSelect(e: TypeaheadMatch): void {
    let substance: Substance = e.item;

    this.control.get('substances.0.substance_group_id').setValue(substance.substance_group.cuid);
    this.control.get('substances.0.substance_group_id').markAsTouched();

  }

  public createNewMedicine(medicineInput?): Observable<ApolloQueryResult<CreateMedicineResult>> {
    medicineInput = medicineInput ? medicineInput : this.control.getRawValue();
    return this.medService.createMedicine(medicineInput);
  }

  public updateMedicine(medicineCuid?, medicineInput?): Observable<ApolloQueryResult<UpdateMedicineResult>> {
    medicineCuid = medicineCuid ? medicineCuid : this.control.get('cuid').value;
    medicineInput = medicineInput ? medicineInput : this.control.getRawValue();
    return this.medService.updateMedicine(medicineCuid, medicineInput);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/medicine/medicine-form/medicine-form.component.ts